module.exports = __webpack_public_path__ + "img/crm1.04eea20a.png";